var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemChannelYoutubeFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 18,
  x: 3,
  y: 3,
  fill: "#CD201F",
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M12.119 7.5c.784.006 5.125.067 5.685.652.618.644.625 3.827.625 3.845v.012c-.002.213-.028 3.21-.625 3.834-.616.643-5.806.657-5.806.657s-5.19-.014-5.807-.657c-.55-.573-.612-3.147-.619-3.729v-.232c.007-.58.07-3.157.619-3.73.56-.585 4.9-.646 5.685-.651ZM10.07 9.43v5.142L15.214 12z"
}))));
export default SvgGemChannelYoutubeFilled;